import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FicheControleTypeStatut } from 'src/api/models';

@Component({
  selector: 'app-statut-checklist',
  templateUrl: './statut-checklist.component.html',
  styleUrls: ['./statut-checklist.component.css']
})
export class StatutChecklistComponent implements OnInit {

  @Input() statut: FicheControleTypeStatut;

  @Input() cell: any;
  @Input() allowEdit: boolean = true;
  @Output() statutChange = new EventEmitter<any>();

  Init = null;

  Ok = false;
  Nok = false;
  Nc = false;

  constructor() { }

  ngOnInit(): void {
    if(this.statut != null) {
      this.Init = JSON.parse(JSON.stringify(this.statut));
    }

    this.initStatut();
  }

  initStatut(){
    switch(this.statut){
      case FicheControleTypeStatut.OK:
        this.Ok = true;
        break;
      case FicheControleTypeStatut.NOK:
        this.Nok = true;
        break;
      case FicheControleTypeStatut.NC:
        this.Nc = true;
        break;
    }
  }

  handleValueChange(event, name: string){
    switch(name){
      case 'OK':
        if(event.value){
          this.statut = FicheControleTypeStatut.OK
          this.Nok = false;
          this.Nc = false;
        }
        break;
      case 'NOK':
        if(event.value){
          this.statut = FicheControleTypeStatut.NOK
          this.Ok = false;
          this.Nc = false;
        }
        break;
      case 'NC':
        if(event.value){
          this.statut = FicheControleTypeStatut.NC
          this.Ok = false;
          this.Nok = false;
        }
        break;
    }
    if (!!this.cell && this.Init != this.statut) {
      this.cell.setValue(this.statut);
    }
    this.statutChange.emit(this.statut);
  }

}
